export const DISABLE_APP_TRUE = "GENERAL/DISABLE_APP_TRUE";
export const ENABLE_APP_TRUE = "GENERAL/ENABLE_APP_TRUE";
export const GET_DATA_SUCCESS = "GENERAL/GET_DATA_SUCCESS";
export const USER_AUTHENTICATED = "GENERAL/USER_AUTHENTICATED";
export const USER_UNAUTHORIZED = "GENERAL/USER_UNAUTHORIZED";
export const CHANGE_TAB_ACTIVE = "GENERAL/CHANGE_TAB_ACTIVE";
export const GET_PROFILE_ERROR = "GENERAL/GET_PROFILE_ERROR";
export const GET_PROFILE_SUCCESS = "GENERAL/GET_PROFILE_SUCCESS";
export const REGISTER_SUCCESS = "GENERAL/REGISTER_SUCCESS";
export const VERIFICATION_SUCCESS = "GENERAL/VERIFICATION_SUCCESS";
export const REGISTRATION_COMPLETE = "GENERAL/REGISTRATION_COMPLETE";
export const GET_ADDRESSES_SUCCESS = "GENERAL/GET_ADDRESSES_SUCCESS";
export const POST_ADDRESSES_SUCCESS = "GENERAL/POST_ADDRESSES_SUCCESS";
export const PUT_ADDRESSES_SUCCESS = "GENERAL/PUT_ADDRESSES_SUCCESS";
export const DELETE_ADDRESSES_SUCCESS = "GENERAL/DELETE_ADDRESSES_SUCCESS";
export const GET_DEVICE_TOKEN_SUCCESS = "GENERAL/GET_DEVICE_TOKEN_SUCCESS";
export const GET_DEVICE_TOKEN_ERROR = "GENERAL/GET_DEVICE_TOKEN_ERROR";
export const HEALTH_INFO_OK = "GENERAL/HEALTH_INFO_OK";
export const HEALTH_INFO_ERROR = "GENERAL/HEALTH_INFO_ERROR";
export const GET_PUSH_NOTIFICATION_TOKEN_SUCCESS = "GENERAL/GET_PUSH_NOTIFICATION_TOKEN_SUCCESS";
export const GET_CONFIG_SUCCESS = "GENERAL/GET_CONFIG_SUCCESS";
export const GET_CLIENT_INFO_SUCCESS = "GENERAL/GET_CLIENT_INFO_SUCCESS";
export const GET_EDIT_PROFILE_SUCCESS = "GENERAL/GET_EDIT_PROFILE_SUCCESS";
export const CHANGE_AVAILABILITY = "GENERAL/CHANGE_AVAILABILITY";
export const VISIBLE_MAIN_TOOLBAR = "GENERAL/VISIBLE_MAIN_TOOLBAR";
export const VISIBLE_SEARCH_VIEW = "GENERAL/VISIBLE_SEARCH_VIEW";
export const VISIBLE_CART_VIEW = "GENERAL/VISIBLE_CART_VIEW";

export function disableApp() {
  return {
    type: DISABLE_APP_TRUE,
    payload: {}
  }
}

export function enableApp() {
  return {
    type: ENABLE_APP_TRUE,
    payload: {}
  }
}

export function changeVisibleSearchView(visible) {
  return {
    type: VISIBLE_SEARCH_VIEW,
    payload: {
      visible
    }
  }
}

export function changeVisibleCartView(visible) {
  return {
    type: VISIBLE_CART_VIEW,
    payload: {
      visible
    }
  }
}

export function changeVisibleMainToolbar(visible) {
  return {
    type: VISIBLE_MAIN_TOOLBAR,
    payload: {
      visible
    }
  }
}

export function changeAvailability(value) {
  return {
    type: CHANGE_AVAILABILITY,
    payload: {
      value
    }
  }
}

/**
 * User authenticated
 * @param {Object} user
 */
export function authenticated(user, token) {
  return {
    type: USER_AUTHENTICATED,
    payload: {
      user,
      token
    }
  }
}

export function changeTab(tab) {
  return {
    type: CHANGE_TAB_ACTIVE,
    payload: {
      tab
    }
  }
}

/**
 * User unauthorized
 * @param {Object} user
 */
export function unauthorized() {
  return {
    type: USER_UNAUTHORIZED,
    payload: null
  }
}

/**
 * change splash
 * @param {Bool} show 
 */
export function changeSplash(show = true) {
  return {
    type: GET_DATA_SUCCESS,
    payload: show
  };
};

export function getProfileError() {
  return {
    type: GET_PROFILE_ERROR,
    payload: null
  };
};

export function getProfileSuccess(customer) {
  return {
    type: GET_PROFILE_SUCCESS,
    payload: {
      customer
    }
  };
};

export function registerSuccess() {
  return {
    type: REGISTER_SUCCESS,
    payload: {}
  }
}

export function verificationSuccess(customer) {
  return {
    type: VERIFICATION_SUCCESS,
    payload: {
      customer
    }
  }
}

export function registerFinalizeSuccess() {
  return {
    type: REGISTRATION_COMPLETE,
    payload: {}
  }
}

export function getAddressesSuccess(addresses) {
  return {
    type: GET_ADDRESSES_SUCCESS,
    payload: {
      addresses
    }
  }
}

export function addAddressSuccess(addresses) {
  return {
    type: POST_ADDRESSES_SUCCESS,
    payload: {
      addresses
    }
  }
}

export function editAddressSuccess(addresses) {
  return {
    type: PUT_ADDRESSES_SUCCESS,
    payload: {
      addresses
    }
  }
}

export function deleteAddressSuccess(id) {
  return {
    type: DELETE_ADDRESSES_SUCCESS,
    payload: {
      id
    }
  }
}

export function getDeviceTokenSuccess(device_token) {
  return {
    type: GET_DEVICE_TOKEN_SUCCESS,
    payload: {
      device_token
    }
  }
}

export function getDeviceTokenUnSuccess() {
  return {
    type: GET_DEVICE_TOKEN_ERROR,
    payload: {}
  }
}

export function healthinfoSuccess() {
  return {
    type: HEALTH_INFO_OK,
    payload: {}
  }
}

export function healthinfoError() {
  return {
    type: HEALTH_INFO_ERROR,
    payload: {}
  }
}

export function updatePushNotificationDataSuccess(token) {
  return {
    type: GET_PUSH_NOTIFICATION_TOKEN_SUCCESS,
    payload: {
      token
    }
  }
}

export function configSuccess(env) {
  return {
    type: GET_CONFIG_SUCCESS,
    payload: {
      env
    }
  }
}

export function getClientInfoSuccess(client) {
  return {
    type: GET_CLIENT_INFO_SUCCESS,
    payload: {
      client
    }
  }
}

export function editProfileSuccess(customer) {
  return {
    type: GET_EDIT_PROFILE_SUCCESS,
    payload: {
      customer
    }
  }
}